import { render, staticRenderFns } from "./returnVisitSOPList.vue?vue&type=template&id=021c5754&scoped=true&"
import script from "./returnVisitSOPList.vue?vue&type=script&lang=js&"
export * from "./returnVisitSOPList.vue?vue&type=script&lang=js&"
import style0 from "./returnVisitSOPList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./returnVisitSOPList.vue?vue&type=style&index=1&id=021c5754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c5754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021c5754')) {
      api.createRecord('021c5754', component.options)
    } else {
      api.reload('021c5754', component.options)
    }
    module.hot.accept("./returnVisitSOPList.vue?vue&type=template&id=021c5754&scoped=true&", function () {
      api.rerender('021c5754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/returnVisitSOPList.vue"
export default component.exports